import { Icon } from './Icon'
import type { IconProps } from './Icon'
export const PlusIcon = (p: IconProps) => <Icon {...p}><path d="M12 5v14M5 12h14" /></Icon>
